<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form v-if="factorIds.length > 0" ref="form" :model="model" @keydown.native.enter.prevent="onSaveBtnClick">
      <el-form-item :label="radio === 1 ? '选择因子' : '选择站房仪器因子'" prop="factorIds">
        <div style="width:100%;clear:both;">
          <el-checkbox-group v-model="model.factorIds">
            <el-checkbox
              v-for="factorId in factorIds"
              :key="factorId"
              :label="factorId"
            >{{radio === 1 ? factorMap[factorId].name : deviceStatusMap[factorId].name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>
    <div v-else style="font-size:24px;display:flex;justify-content:center;align-items:center;width:100%;height:100%;">该设备没有{{radio === 1 ? '因子' : '状态'}}可供添加！</div>
  </template>

  <template #footer>
    <el-button :disabled="model.factorIds.length === 0" type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'

export default {
  name: 'SiteDeviceFactorCreator',
  extends: BaseEditor,
  props: {
    siteDevice: {
      required: true
    },
    siteDeviceFactors: {
      required: true
    },
    radio: {
      required: true
    },
    deviceStatusMap: {
      type: Object
    }
  },
  data: () => ({
    factorIds: Object.freeze([])
  }),
  computed: {
    apiKey () {
      return this.radio === 1 ? 'SiteDeviceFactor' : 'SiteDeviceStatus'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return this.radio === 1 ? '站房仪器因子' : '站房仪器状态'
    }
  },
  methods: {
    initModel () {
      let {siteDevice} = this

      return {
        siteDeviceId: siteDevice ? siteDevice.id : null,
        factorIds: []
      }
    },
    onOpen () {
      this.changeLoadStatus(true)
      this.$api[this.apiKey].getFactorsBySiteDeviceId(this.siteDevice.id).then(factorIds => {
        this.factorIds = Object.freeze(factorIds)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getFactorTree () {
      return this.$refs['factor-tree']
    },
    onFactorCheckChange () {
      let checkedFactorList = this.getFactorTree().getCheckedNodes()
      this.model.factorIds = checkedFactorList.filter(item => !Array.isArray(item.children)).map(item => item.id)
    },
    onSaveBtnClick () {
      this.changeLoadStatus(true)
      let model = JSON.parse(JSON.stringify(this.model))
      if (this.radio === 2) {
        model.statusIds = model.factorIds
        delete model.factorIds
      }

      this.$api[this.apiKey].batchSave(model).then(data => {
        if (data) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success',
            position: 'bottom-right'
          })

          this.saveCallback()
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteDeviceFactorCreator.vue